module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_card_3_.eb021048.png";